module.exports = __webpack_public_path__ + "static/media/logo_addiv.eedfbf23.webp";